import { answerExclusive, createAnswerSchema } from '../../../poll/questions/answerSchemaFields';
import { createQuestionSchema, questionRequiresAnswer } from '../questionSchemaFields';
import { config } from './TextareaPoll.config';

export const schema = createQuestionSchema(
  {
    type: 'object',
    properties: {
      type: { enum: [config.name] },
      answers: {
        type: 'array',
        items: createAnswerSchema(answerExclusive),
      },
      textareaType: {
        enum: ['TEXT', 'PHONE', 'EMAIL', 'DATE', 'NUMBER', 'URL'],
      },
      textLabel: { type: 'string' },
      textLimit: { type: 'number' },
      textReplaceUnsafe: { type: 'boolean' },
    },
    required: ['textareaType', 'textLimit', 'textReplaceUnsafe', 'answers'],
  },
  questionRequiresAnswer,
);
